// extracted by mini-css-extract-plugin
export default {"wrapper":"BillingDetailsForm_wrapper__YXHQj","button":"BillingDetailsForm_button__Ca56E","loader":"BillingDetailsForm_loader__Eo11w","spin":"BillingDetailsForm_spin__8dRHy"};